/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contact__header[_ngcontent-%COMP%]{background:#dbf6fb;padding:12px 30px;font-size:13px;font-weight:700}.contact__body[_ngcontent-%COMP%]{font-size:14px;line-height:1.4;padding:12px 30px}.contact__name[_ngcontent-%COMP%]{color:#383838;font-weight:700}.contact__remarks[_ngcontent-%COMP%]{display:block;margin-top:1em}.contact__remark-label[_ngcontent-%COMP%]{padding-left:12px;text-transform:uppercase;font-size:12px;font-weight:700;color:#777;margin-bottom:.6em}.contact__address[_ngcontent-%COMP%]{font-size:14px;line-height:1.24}"];
export { styles as styles };
